// src/components/pageContent/PageContentBox.tsx
import { useAuth0 } from "@auth0/auth0-react";
import { Box, SxProps, useMediaQuery, useTheme } from "@mui/material";
import { CasLoader } from "../brand/CasLoader";
import React from "react";
import { useSideNavOpen } from "../../hook/sideNav";
import { useWorkspaceSwitching } from "../../context/workspaceSwitching";

interface PageContentBoxProps {
  children?: React.ReactNode;
  drawerWidth: string;
}

const PageContentBox: React.FC<PageContentBoxProps> = ({
  children,
  drawerWidth,
}) => {
  const { sideNavOpen } = useSideNavOpen();
  const { isAuthenticated } = useAuth0();
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.up("md"));
  const { isSwitching } = useWorkspaceSwitching();
  const paddingSx: SxProps = isMediumScreen
    ? { padding: "4rem" }
    : { padding: "1rem", paddingLeft: "2rem" };

  return (
    <Box
      position="absolute"
      sx={{
        minHeight: "40rem",
        transition: (theme) =>
          theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        width:
          isAuthenticated && sideNavOpen
            ? `calc(100% - ${drawerWidth})`
            : "100%",
        marginLeft: isAuthenticated && sideNavOpen ? `${drawerWidth}` : 0,
        overflow: "scroll",
        ...paddingSx,
        paddingTop: 12,
      }}
    >
      {isSwitching && (
        <CasLoader
          size={32}
          label="Switching workspace"
          sx={{
            position: "absolute",
            top: 8,
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 10,
          }}
        />
      )}
      {children}
    </Box>
  );
};

export default PageContentBox;
